import React, {useState} from "react";
import Img1 from "../../images/about/1.webp";
import Img2 from "../../images/about/2.webp";
import Img3 from "../../images/about/4.webp";
import {Link, useLocation} from "react-router-dom";
import '../../css/about.css';
import {findElementByLink} from "../utils/siteStructure";
import siteStructure from "../siteStructure.json";
import SeoHelmet from "../utils/seo";
import {useTheme} from "../header/Header";

export default function About() {

    const { theme } = useTheme()

    const location = useLocation();
    const data = findElementByLink(siteStructure, location.pathname)
    const seo = data.seo? data.seo : {title:"", description:"", keywords:"", changefreq: 'yearly', priority: 0.4}

    const [currentImage, setCurrentImage] = useState(Img2);
    const [isFading, setIsFading] = useState(false);

    const menuItems = [
        {text: "Контакты", image: Img1, nav: '/about/contacts'},
        {text: "О предприятии", image: Img2, nav:'/about/company'},
        {text: "Сеспель в соцсетях", image: Img3, nav: '/about/socialLinks'},
    ];

    const changeImage = (newImage) => {
        if (newImage === currentImage) return; // Проверка: если изображение уже активное, ничего не делаем
        setIsFading(true); // Запускаем эффект исчезновения
        setTimeout(() => {
            setCurrentImage(newImage); // Меняем изображение
            setIsFading(false); // Возвращаем прозрачность
        }, 500); // Время анимации совпадает с CSS (0.5s)
    };
    return (
        <div className={`overlay`}>

            <SeoHelmet
                title={seo.title}
                description={seo.description}
            />

            <div className="menuAbout-container">
                <div className={`complexBack ${theme}`}> </div>
                {/* Левое меню */}
                <div className={`menuAbout ${theme}`}>
                    <ul>
                        {menuItems.map((item, index) => (
                            <li key={index}
                                onMouseEnter={() => changeImage(item.image)}
                                className="menuAbout-item"
                            >
                                <Link to={item.nav}>{item.text}</Link>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Блок с изображением */}
                <div className={`menuAbout-image-container ${theme}`}>
                    <img
                        src={currentImage}
                        alt="Menu"
                        className={`menuAbout-image ${isFading ? "fade-out" : "fade-in"}`}
                    />
                </div>
            </div>
        </div>
    );
}
